// extracted by mini-css-extract-plugin
export default {"svg_logo":"SVGLogo_svg_logo__WjSfK","inner":"SVGLogo_inner__SbrJ5"};